import io from "socket.io-client"
import user, { User } from './user';

export default class ChatSocket {
	constructor() {
		this.handlers = {
			'new-message': [],
			'typing': [],
		};
		if (!hp.store.chat) {
			hp.store.chat = {
				until: null,
				data: {},
				users: {},
				unread: {} // guarda, por user, o numero de mensagens não lidas
			}
		}
		this.socket = io(hp.settings.chat.server);
		this.socket
			.on('new-message', (data) => {
				if (!window.document.hasFocus()) {
					const notif = new Audio(hp.settings.tpldns + 'media.510191266/notification.mp3');
					notif.play();
				}
			// vai buscar a mensagem gravada
				this.load();
				// se user_id que enviou mensagem não está na lista de user_ids
			})
			.on('typing', (data) => {
				if (hp.store.chat.users.hasOwnProperty(data.user_id)) {
					hp.store.chat.users[data.user_id].typing = data.typing;
					this.raiseEvents('typing', data);
				}
			})
		this.load();
	}
/*
	init(user_ids) {
		if (!this.socket) {
			this.socket = io(hp.settings.chat.server);
			this.socket
				.on('new-message', (data) => {
					// vai buscar a mensagem gravada
					debugger;
					this.load();
					// se user_id que enviou mensagem não está na lista de user_ids
				})
				.on('typing', (data) => {
					if (hp.store.chat.users.hasOwnProperty(data.user_id)) {
						hp.store.chat.users[data.user_id].typing = data.typing;
						this.raiseEvents('typing', data);
						//this.forceUpdate();
					}
				})
				//.on('reconnect', (number) => this.socket.emit('add-user', hp.settings.chat.nif, {id: user.main.uid, rooms: user_ids || [], token: hp.store.chatoken}));
		}
		this.socket
			.emit('add-user', hp.settings.chat.nif, {id: user.main.uid, rooms: user_ids || [], token: hp.settings.chat.token})
			.on('reconnect', number => this.socket.emit('add-user', hp.settings.chat.nif, {id: user.main.uid, rooms: user_ids || [], token: hp.store.chatoken}));
	}
*/
	subscribe(type, handler) {
		if (!this.handlers[type]) {
			return -1;
		}
		const idx = Object.keys(this.handlers[type]).length;
		this.handlers[type][idx] = handler;
		return idx;
	}

	unsubscribe(type, handlerIdx) {
		if (this.handlers[type] && this.handlers[type].hasOwnProperty(handlerIdx)) {
			delete this.handlers[type][handlerIdx];
		}
	}

	raiseEvents(type, params = null) {
		if (this.handlers[type]) {
			setTimeout( () => {
				this.handlers[type].forEach(handler => {
					handler.apply(params);
				})
			});
		}
	}

	send(data) {
		return new Promise((resolve, success) => {
			http.post('/home/chatSend.json', data, response => {
				if (response) {
					// tell server to execute 'new message' and send along one parameter
					this.socket.emit('new-message', data);
					this.mergeResults(response);
					resolve(response);
				}
			})
		});
	}

	setUnread(uid) {
		if (this.read_timeout) {
			clearTimeout(this.read_timeout);
		}
		this.read_timeout = setTimeout(() => {
			http.post('/home/setChatRead.json', {to: uid, silent: true}, response => {
				const chat = hp.store.chat;
				this.read_timeout = 0;
				delete chat.unread[uid];
				// definir todas as mensagens como lidas
				const user_msgs = chat.data[uid] || {};
				Object.keys(user_msgs).forEach(id => {
					user_msgs[id].read = 1
				});
				this-this.raiseEvents('new-message');
			});
		}, 1000);
	}

	load(to = null) {
		if (!user.main.uid) {
			return;
		}
		const {chat} = hp.store;
		let users = to && !user.get(to) ? [to] : null;

		http.post('/home/getChat.json', {since: chat.until, silent: true, users: users}, response => {
			const merged = this.mergeResults(response)
			if (response.chat) {
				const user_ids = Object.keys(response.chat);

				//this.init(Object.keys(response.chat));
				this.socket
					.emit('add-user', hp.settings.chat.nif, {id: user.main.uid, rooms: user_ids || [], token: hp.settings.chat.token})
					.on('reconnect', number => this.socket.emit('add-user', hp.settings.chat.nif, {id: user.main.uid, rooms: user_ids || [], token: hp.store.chatoken}));
				this.raiseEvents('new-message', {chat: response});
				/*
				if (!this.state.active && (users = Object.keys(chat.users)).length > 0) {
					this.state.active = users[0];
				}
				// se user ativo, 
				if (this.state.active && chat.unread[this.state.active] > 0) {
					this.onSelectUser(this.state.active);
				}
				this.forceUpdate();
				*/
			}
		})

	}

	mergeResults(response) {
		const {chat} = hp.store;
		const user_ids = Object.keys(response.chat);

		chat.until = response.until;
		user_ids.forEach(uid => {
			const msgs = response.chat[uid];

			Object.keys(msgs).forEach(mid => {
				msgs[mid].updated_at = new Date(msgs[mid].updated_at)
			});
			if (chat.data.hasOwnProperty(uid)) {
				Object.assign(chat.data[uid], msgs);
			}
			else {
				chat.data[uid] = msgs;
			}
		});
		Object.assign(chat.unread, response.unread);
		User.merge(response.users);
		Object.keys(response.users).forEach(uid => {
			chat.users[uid] = user.get(uid).profile
		});
		//this.setSocket(user_ids);
		return user_ids.length > 0;
	}

}
